import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer-section">
      <ul className="social-icons">
        <li>
          <a
            href="https://www.facebook.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={`${process.env.PUBLIC_URL}/images/Facebook_logo_(square).png`}
              alt="Facebook"
            />
          </a>
        </li>

        <li>
          <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
            <img
              src={`${process.env.PUBLIC_URL}/images/Logo_of_Twitter.png`}
              alt="Twitter"
            />
          </a>
        </li>

        <li>
          <a
            href="https://www.instagram.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={`${process.env.PUBLIC_URL}/images/instagaram.jpg`}
              alt="Instagram"
            />
          </a>
        </li>

        <li>
          <a href="https://youtube.com" target="_blank" rel="noopener noreferrer">
            <img
              src={`${process.env.PUBLIC_URL}/images/youtube.png`}
              alt="YouTube"
            />
          </a>
        </li>
      </ul>

      <p className="footer-links">
        <Link to="/copyright">Copyright Policy</Link> |{" "}
        <Link to="/disclaimer">Disclaimer</Link> |{" "}
        <Link to="/privacy">Privacy Policy</Link> |{" "}
        <Link to="/contact">Contact Us</Link>
      </p>

      <p>
        Website Designed, Developed & Maintained by{" "}
        <b>Certnexus India Pvt. Ltd. Nagpur</b>
        <br />
        Content provided by Grampanchayat Office, Government of Maharashtra.
      </p>

      <p>© 2025 Certnexus India Pvt. Ltd. Nagpur</p>

      <div className="footer-logos">
        <a
          href="https://swachhbharatmission.ddws.gov.in/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={`${process.env.PUBLIC_URL}/images/swachh-bharat.png`}
            alt="Swachh Bharat"
          />
        </a>

        <a href="https://digitalindia.gov.in" target="_blank" rel="noopener noreferrer">
          <img
            src={`${process.env.PUBLIC_URL}/images/digital-india-logo.png`}
            alt="Digital India"
          />
        </a>

        <a href="https://data.gov.in" target="_blank" rel="noopener noreferrer">
          <img
            src={`${process.env.PUBLIC_URL}/images/data-gov-logo.png`}
            alt="Data Portal"
          />
        </a>

        <a href="https://www.india.gov.in" target="_blank" rel="noopener noreferrer">
          <img
            src={`${process.env.PUBLIC_URL}/images/portal.jpg`}
            alt="National Portal"
          />
        </a>

        <a href="https://mygov.in" target="_blank" rel="noopener noreferrer">
          <img
            src={`${process.env.PUBLIC_URL}/images/mygov.png`}
            alt="MyGov"
          />
        </a>

        <a href="https://www.meity.gov.in" target="_blank" rel="noopener noreferrer">
          <img
            src={`${process.env.PUBLIC_URL}/images/Meity_logo.png`}
            alt="MeitY"
          />
        </a>

        <a href="https://pmindia.gov.in" target="_blank" rel="noopener noreferrer">
          <img
            src={`${process.env.PUBLIC_URL}/images/pm-india-logo.jpg`}
            alt="PM India"
          />
        </a>
      </div>
    </footer>
  );
};

export default Footer;